[<RequireQualifiedAccess>]
module SideBar

open Shared
open ViewTypes
open Feliz
open System
open API
open RenderHelpers

let isActiveLijst (selectedLijst: Lijst option) (lijst: Lijst) =
    match selectedLijst with
    | None -> lijst.Name = "All Songs"
    | Some lijst' -> lijst'.Id = lijst.Id

//let btnElm (faclass: string) (dispatch: Msg->unit) dispfun extraCls =
//    Html.button [ prop.className ("button level-item" + " " + extraCls)
//                  prop.onClick (fun _ -> dispatch dispfun)
//                  prop.children [ Html.i [ prop.className faclass ] ] ]

let sideBarHead (state: State) (dispatch: Msg -> unit)=
    let levelLeft=
        Html.strong [ prop.text "Lists" ]
        |>wrap1In Html.div "level-left"

    let isNewLijst =
        state.Song.SelectedSong.IsNone && not state.Lijst.WijzigLijst

    let levelRight =
        if isNewLijst
        then
            btnElm "fa fa-file" dispatch (NieuwLijstClicked(Lijst.create "new list")) "has-text-danger"
            |> wrap1In Html.div "level-right"
        else Html.none

    [ levelLeft; levelRight ]
    |> wrapxIn Html.div "level is-mobile"

let sideBarItem (lijst: Lijst) (selectedlijst: Lijst option) (dispatch: Msg -> unit) =
    let isActiveLijst = isActiveLijst selectedlijst

    Html.a [ prop.onClick (fun _ -> dispatch (LijstClicked lijst.Id))
             prop.className (if isActiveLijst lijst then "is-active" else "")
             prop.children [
                 Html.span [
                    prop.className "is-size-5"
                    prop.text lijst.Name ]
                 ] ]

let render (state: State) (dispatch: Msg -> unit) =
    let sortedlijsten =
        state.Lijsten
        |> List.sortByDescending (fun lijst -> lijst.Created)
        |> fun lijsten -> Lijst.create "All Songs" :: lijsten

    Html.aside [ prop.children [
        sideBarHead state dispatch
        //Html.strong [ prop.text "Lists" ]
        Html.div [
            prop.className "menu-list"
            prop.children [
                for lijst in sortedlijsten do
                (sideBarItem lijst state.Lijst.SelectedLijst dispatch) ] ]
        Html.hr [] ] ]